var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseEntity, Default, Transform, toEntity } from './base';
import { NoteModel } from './note';
import { UserAddressModel } from './user-address';
export class UserModel extends BaseEntity {
}
__decorate([
    Default(false),
    __metadata("design:type", Boolean)
], UserModel.prototype, "admin", void 0);
__decorate([
    Default(false),
    __metadata("design:type", Boolean)
], UserModel.prototype, "filler", void 0);
__decorate([
    Default(false),
    __metadata("design:type", Boolean)
], UserModel.prototype, "provider", void 0);
__decorate([
    Transform(toEntity(NoteModel)),
    __metadata("design:type", Array)
], UserModel.prototype, "notes", void 0);
__decorate([
    Transform(toEntity(UserAddressModel)),
    __metadata("design:type", Array)
], UserModel.prototype, "userAddresses", void 0);
//# sourceMappingURL=user.js.map


// WEBPACK FOOTER //
// ./src/models/user.ts.pre-build-optimizer.js